import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';

export default class OrderAddPeopleDirectiveController {
    static $inject = ['$scope', '$rootScope', 'ContactsService', '$mdToast', 'UserProfile', 'Message', 'Session', '$translate'];

    constructor(scope, rootScope, contactsService, toastService, userProfileService, messageService, sessionService, $translate) {
        this._scope = scope;
        this._rootScope = rootScope;
        this._userEmails = {};
        this._excludedEmails = {};
        this._allContactsAndGroups = [];
        this._contactsService = contactsService;
        this._userProfileService = userProfileService;
        this._messageService = messageService;
        this._toastService = toastService;
        this._sessionService = sessionService;
        this.$translate = $translate;

        scope.foundContacts = [];
        scope.addAsGroup = false;
        scope.selectedEmails = scope.selectedEmails || [];
        scope.selectedContacts = scope.selectedContacts || [];
        scope.created = scope.created || [];
        scope.selectedTwoContacts = false;
        scope.groupNameToAdd = '';
        scope.nameToAdd = '';
        scope.context = scope.context || {};
        scope.context.contacts = scope.context.contacts || [];
        scope.recent = [];
        scope.allContactsMinusRecent = [];
        scope.showErrorMessage = false;
        scope.errorMessage = '';
        scope.addSelectedContactsToGroup = () => this._addSelectedContactsToGroup();
        scope.selectContact = contact => this._selectContact(contact);
        scope.unselectContact = contact => this._unselectContact(contact);
        scope.nameToAddChanged = () => this._nameToAddChanged();
        scope.closeFoundContactsForm = () => this._closeFoundContactsForm();
        scope.nameToAddKeyPressed = event => this._nameToAddKeyPressed(event);
        scope.groupToAddKeyPressed = event => this._groupToAddKeyPressed(event);
        scope.addEnteredEmails = () => this._addEnteredEmails();
        scope.updateSelectedContacts = () => this._updateSelectedContacts();

        scope.onNextBtnClicked = () => this._onNextBtnClicked();
        scope.onBackBtnClicked = () => this._onBackBtnClicked();
        scope.onDeleteContactClicked = (contact) => this._onDeleteContactClicked(contact);

        scope.$on(Constants.Events.ADD_PEOPLE_ADVANCE_TO_NEXT_PAGE, () => this._addEnteredEmails(true));
    }

    async $onInit() {
        const contactsLoaded = !!this._scope.context.contacts && this._scope.context.contacts.length;
        if (contactsLoaded) {
            this._addContextContacts();
        } else {
            await this._getUserAndContacts();
        }
    }

    async _fetchGroups() {

        const groups = await this._contactsService.getGroups();

        this._scope.context.contacts = this._scope.context.contacts || [];
        this._scope.context.groups = [];

        if (!groups || !groups.length) {
            scopeUtils.apply(this._scope);
            return;
        }

        _.each(groups, item => this._onGroupReceived(item));

        this._updateRecentContacts();
        this._sortContactsAndGroups();
        this._updateSelectableGroups();

        scopeUtils.apply(this._scope);
    }

    async _onGroupReceived(groupDefinition) {

        const group = this._initializeGroup(groupDefinition.name);

        let forcedSelected = 0;

        _.each(groupDefinition.groupMembers, async groupMember => {

            let contact = _.find(this._scope.context.contacts, {email: groupMember.memberEmail});

            if (!contact) {
                contact = await this._initializeContact(groupMember.memberName, groupMember.memberEmail);
                contact.forcedSelected = this._userEmails[contact.email] || this._excludedEmails[contact.email];
                this._scope.context.contacts.push(contact);
                this._allContactsAndGroups.push(contact);
            }

            if (contact.forcedSelected) {
                contact.selected = true;
                forcedSelected++;
            }

            group.contacts.push(contact);
        });

        group.forcedSelected = group.contacts.length === forcedSelected;

        if (group.forcedSelected) {
            group.selected = true;
        }

        this._scope.context.groups.push(group);
        this._allContactsAndGroups.push(group);

        scopeUtils.apply(this._scope);
    }

    async _fetchContacts() {
        const contacts = await this._contactsService.getContacts();

        this._scope.context.contacts = this._scope.context.contacts || [];

        if (!contacts || !contacts.length) {
            scopeUtils.apply(this._scope);
            return;
        }

        for (let i in contacts) {
            let item = contacts[i];

            let contact = _.find(this._scope.context.contacts, {email: item.email});

            if (!contact) {
                contact = await this._initializeContact(item.name, item.email, item.recent, item.avatar, item.userId, item.contactUserId);
                contact.forcedSelected = this._userEmails[contact.email] || this._excludedEmails[contact.email];
                this._scope.context.contacts.push(contact);
                this._allContactsAndGroups.push(contact);
            }
        }

        this._updateRecentContacts();
        this._sortContactsAndGroups();
        scopeUtils.apply(this._scope);
    }

    _addContextContacts() {

        // which means we have already read all data

        _.each(this._scope.context.groups, group => {
            this._allContactsAndGroups.push(group);
        });

        _.each(this._scope.context.contacts, contact => {
            this._allContactsAndGroups.push(contact);
        });

        this._updateRecentContacts();
    }

    async _getUserAndContacts() {

        const user = await this._userProfileService.getUser();

        _.each(user.userEmails, item => {
            this._userEmails[item.email] = true;
        });

        if (this._scope.exclude) {
            this._scope.exclude.forEach(email => {
                this._excludedEmails[email] = true;
            });
        }

        scopeUtils.apply(this._scope, () => {
            this._scope.loading = true;
        });
        await this._fetchGroups();
        await this._fetchContacts();
        scopeUtils.apply(this._scope, () => {
            this._scope.loading = false;
        });
    }

    _updateSelectableGroups() {
        this._scope.selectableGroups = _.filter(this._scope.context.groups, {
            forcedSelected: false
        });
    }

    _addSelectedContactsToExistingGroup(group) {

        const addedContacts = _.map(group.contacts, contact => contact.email);
        let contactsAdded = false;

        _.each(this._scope.selectedContacts, contact => {

            if (contact.isGroup) {
                return;
            }

            if (_.some(group.contacts, {email: contact.email})) {
                return;
            }

            contactsAdded = true;
            group.contacts.push(contact);
            contact.selected = false;
            addedContacts.push(contact.email);
        });

        group.selected = true;

        if (contactsAdded) {
            group.forcedSelected = false;
            this._contactsService.updateGroup(group.name, addedContacts)
                .catch(error => this._messageService.showErrorPopupForResponse(error));
        }

        this._scope.updateSelectedContacts();
        this._updateSelectableGroups();

        this._scope.addAsGroup = false;
        this._scope.groupNameToAdd = '';
    }

    async _addSelectedContactsToGroup() {

        const groupName = _.trim(this._scope.groupNameToAdd);
        if (groupName.length === 0) {
            return;
        }

        let group = _.find(this._scope.context.groups, {name: groupName});

        const addedContacts = [];

        if (group) {
            this._addSelectedContactsToExistingGroup(group);
            return;
        }

        group = this._initializeGroup(groupName);

        _.each(this._scope.selectedContacts, contact => {

            if (!contact.isGroup) {
                group.contacts.push(contact);
                contact.selected = false;
                addedContacts.push(contact.email);
            }
        });

        group.selected = true;

        this._scope.context.groups.push(group);
        this._allContactsAndGroups.push(group);

        await this._contactsService.createGroup(groupName, addedContacts)
            .catch(error => this._messageService.showErrorPopupForResponse(error));

        this._sortContactsAndGroups();

        this._scope.groupNameToAdd = '';
        this._scope.addAsGroup = false;

        this._updateSelectedContacts();
        this._updateSelectableGroups();
    }

    _selectContact(contact) {
        console.log('_selectContact');
        if (contact.selected) {
            return;
        }

        contact.selected = true;

        this._updateSelectedContacts();
    }

    _unselectContact(contact) {
        console.log('_unselectContact');
        if (!contact.selected) {
            return;
        }

        contact.selected = false;

        this._updateSelectedContacts();
    }

    _updateRecentContacts() {

        this._scope.recentContacts = _.chain(this._scope.context.contacts)
            .filter(contact => contact && (contact.recent || false) && !contact.forcedSelected)
            .sortBy(contact => this._getContactSortBy(contact))
            .value();

        const alreadyInCartContacts = _.chain(this._scope.context.contacts)
            .filter(contact => contact && !(contact.recent || false) && contact.forcedSelected)
            .sortBy(contact => this._getContactSortBy(contact))
            .value();

        this._scope.alreadyInCartContacts = alreadyInCartContacts
            .map(contact => {
                contact.selected = true;
                return contact;
            });

        this._scope.allContactsMinusRecent = _.chain(this._scope.context.contacts)
            .filter(contact => contact && !(contact.recent || false) && !contact.forcedSelected && !contact.selected)
            .sortBy(contact => this._getContactSortBy(contact))
            .value();

        if (this._scope.selectedContacts.length) {
            this._scope.showErrorMessage = false;
        }

        scopeUtils.apply(this._scope);
    }

    _nameToAddChanged() {
        const name = _.trim(this._scope.nameToAdd).toLowerCase();

        if (name.length === 0) {
            this._scope.foundContacts = [];
            return;
        }

        this._scope.foundContacts = _.chain(this._allContactsAndGroups)
            .filter(contact => contact && ((contact.name && contact.name.toLowerCase().includes(name)) || contact.email.includes(name)))
            .sortBy(this._getContactSortBy)
            .take(7)
            .value();
    }

    _closeFoundContactsForm() {
        this._scope.foundContacts = [];
        this._scope.nameToAdd = '';
    }

    async _nameToAddKeyPressed(event) {
        if (!Constants.EMAIL_REGEX.test(this._scope.nameToAdd)) {
            this._rootScope.$broadcast('order:add:people.canAddPeople', false);
            return;
        }
        this._rootScope.$broadcast('order:add:people.canAddPeople', true);

        if (event.which !== 13) {
            return;
        }

        await this._addEnteredEmails();
    }

    _groupToAddKeyPressed(event) {

        if (event.which !== 13) {
            return;
        }

        this._addSelectedContactsToGroup();
    }

    async _initializeContact(name, email, recent, avatar, userId, contactUserId) {
        //
        // if (email === 'david@ultimatetechnical.com'){
        //     debugger;
        // }

        if (!name && !avatar) {
            try {
                let avatarModel = await this._userProfileService.getUserAvatar(email);
                if (avatarModel && avatarModel.data)
                    avatar = avatarModel.data.avatar;
            }
            catch (error) {
                avatar = null;
            }
        }

        return {
            email: _.trim(email).toLowerCase(),
            name: _.trim(name),
            isGroup: false,
            selected: false,
            recent: recent,
            avatar: avatar,
            userId: userId,
            contactUserId: contactUserId
        };
    }

    _initializeGroup(name) {
        return {
            name: name.trim(),
            isGroup: true,
            contacts: [],
            selected: false,
            expanded: false
        };
    }

    async _addEnteredEmail(email, state) {

        email = _.trim(email);
        if (email.length === 0) {
            return;
        }

        const existingContact = this._scope.context.contacts.find(contact => contact.email === email);

        if (existingContact) {
            if (this._excludedEmails[existingContact.email]) {
                if (state.updatedNameToAdd) {
                    state.updatedNameToAdd += ', ';
                }
                state.updatedNameToAdd += email;
                state.excludedEmails.push(email);
                return;
            }

            existingContact.selected = true;
            existingContact.selectedOn = new Date();
            // existingContact.recent = true;
            state.addedEmails++;
        } else {
            if (!Constants.EMAIL_REGEX.test(email)) {
                if (state.updatedNameToAdd) {
                    state.updatedNameToAdd += ', ';
                }
                state.updatedNameToAdd += email;
                state.incorrectEmails++;
                return;
            }

            if (this._excludedEmails[email]) {
                if (state.updatedNameToAdd) {
                    state.updatedNameToAdd += ', ';
                }
                state.updatedNameToAdd += email;
                state.excludedEmails++;
                return;
            }

            const newContact = await this._initializeContact(null, email);

            newContact.selected = true;
            newContact.recent = true;
            this._scope.context.contacts.push(newContact);
            this._allContactsAndGroups.push(newContact);
            this._scope.created.push(newContact);
            state.addedEmails++;
            scopeUtils.apply(this._scope);
        }
    }

    async _addEnteredEmails(sendInvitation) {
        this._scope.errorMessage = '';
        this._scope.showErrorMessage = false;

        const emails = this._scope.nameToAdd.split(/[,; ]/);

        // [CW-735] - prevent owner to invite himself to his cart.
        const ownerEmail = await this._sessionService.getUserEmail();

        let hasOwnerEmail = emails.some((email) => ownerEmail === email);

        if (hasOwnerEmail) {
            this._scope.errorMessage = this.this.$translate.instant('client.cart.invite_restrict');
            this._scope.showErrorMessage = true;
            return;
        }

        const state = {
            addedEmails: 0,
            incorrectEmails: 0,
            excludedEmails: [],
            updatedNameToAdd: ''
        };

        for (let i in emails) {
            let email = emails[i];
            await this._addEnteredEmail(email, state);
        }

        this._sortContactsAndGroups();
        this._updateSelectedContacts(sendInvitation);
        this._closeFoundContactsForm();
        this._updateRecentContacts();

        this._scope.nameToAdd = state.updatedNameToAdd;

        if (state.updatedNameToAdd) {

            let message = '';
            if (state.excludedEmails.length) {
                message = this.$translate.instant('client.cart.exclude_emails', { excludedEmails: state.excludedEmails.join(', '), excludedEmailsLength:  state.excludedEmails.length > 1 ? '' : 's'})
            }
            if (state.incorrectEmails) {
                if (message) {
                    message += ', ';
                }
                message += this.$translate.instant('client.user.valid.email');
            }

            const toast = this._toastService.simple()
                .textContent(state.addedEmails ?
                    this.$translate.instant('client.user.correct_email') : message)
                .position('top');

            // this._toastService.show(toast);
            this._scope.errorMessage = message;
            this._scope.showErrorMessage = true;
        } else {
            this._scope.errorMessage = '';
            this._scope.showErrorMessage = false;
        }
        scopeUtils.apply(this._scope);
    }

    _getContactSortBy(contact) {
        return (contact.name || contact.email).toLowerCase();
    }

    _sortContactsAndGroups() {
        this._scope.context.contacts = _.chain(this._scope.context.contacts)
            .filter(contact => !!contact)
            .sortBy(contact => this._getContactSortBy(contact))
            .value();

        this._scope.context.groups = _.chain(this._scope.context.groups)
            .filter(contact => !!contact)
            .sortBy(contact => this._getContactSortBy(contact))
            .value();
    }

    _updateSelectedContacts(sendInvitation) {
        this._scope.selectedContacts = _.chain(this._allContactsAndGroups)
            .filter(contact => contact && contact.selected && !contact.forcedSelected)
            .sortBy(contact => -((contact.selectedOn || new Date()).getTime()))
            .value();

        this._scope.selectedTwoContacts = _.chain(this._scope.selectedContacts)
            .filter(contact => !contact.isGroup)
            .value().length > 1;

        const emailsSet = {};

        this._scope.selectedContacts.forEach(item => {
            if (item.isGroup) {
                item.contacts.forEach(contact => {
                    emailsSet[contact.email] = true;
                });
            } else {
                emailsSet[item.email] = true;
            }
        });

        this._scope.selectedEmails = _.keys(emailsSet);

        if (this._scope.onChanged) {
            this._scope.onChanged(this._scope.selectedEmails);
        }

        if (sendInvitation && this._scope.sendInvitation) {
            this._scope.sendInvitation(this._scope.selectedEmails);
        }

        this._updateRecentContacts();

        this._rootScope.$broadcast('order:add:people.canAddPeople', this._scope.selectedEmails.length > 0);
    }

    _onNextBtnClicked() {
        if (!this._scope.selectedContacts.length && !this._scope.alreadyInCartContacts.length) {
            this._scope.showErrorMessage = true;
            scopeUtils.apply(this._scope);
            return;
        }

        this._scope.showErrorMessage = false;
        this._scope.goNext();
    }

    _onBackBtnClicked(){
        this._scope.goBack();
    }

    _onDeleteContactClicked(conctact){
        this._scope.deleteContact(conctact);
    }
}

module.directive('cartonomyOrderAddPeople', function () {
    return {
        scope: {
            selectedContacts: '=?selectedContacts',
            selectedEmails: '=?selectedEmails',
            onChanged: '=?onChanged',
            sendInvitation: '=?sendInvitation',
            created: '=?created',
            context: '=?context',
            exclude: '=?exclude',
            title: '@title',
            goNext: '=?goNext',
            goBack: '=?goBack',
            cancelAction: '=?cancelAction',
            showCancelButton: '=?showCancelButton',
            deleteContact: '=?deleteContact',
        },
        transclude: true,
        template: require('../views/addPeopleDirective.pug'),
        controller: OrderAddPeopleDirectiveController
    };
});


// WEBPACK FOOTER //
// ./src/modules/order/directives/OrderAddPeopleDirective.js